const links = [
  {
    id: 1,
    url: "/",
    text: "Home",
  },
  {
    id: 2,
    url: "/projects",
    text: "My projects",
  },
  {
    id: 3,
    url: "/about-me",
    text: "About Me",
  },
  {
    id: 4,
    url: "/contact",
    text: "Contact",
  },
];

export default links;
